import { createFileRoute } from '@tanstack/react-router';
import { myCredentials } from '@/api/resources';
import { warm } from '@/api/loaders';
import { requireCapability } from '@/lib/route-guards';
import { AccountView } from '@/screens/account';

export const Route = createFileRoute('/account')({
  // Every role holds `tokens_issue` at `own` or above (Reporter included, 2026-10-28); the
  // API's `require_capability` admits any level above `none`.
  beforeLoad: requireCapability('tokens_issue', 'own'),
  loader: ({ context }) => warm(context.queryClient, myCredentials(undefined)),
  component: AccountView,
});
